export const getAccesToPortalAfterTerminationOfEmployment = (userExpiryDate: Date | null) => {
    let message =
        'Upozornění: Přístup do portálu po ukončení pracovního poměru bude možné max. 1 měsíc po posledním výplatním termínu – tj. k 15. dni v měsíci';
    if (userExpiryDate) {
        message = `Upozornění: Váš přístup do portálu bude ukončen ke dni: ${userExpiryDate.toLocaleDateString('cs')}`;
    }

    return message;
};
